import type { SnapGuides as SnapGuidesType } from '../utils/snapping';

interface SnapGuidesProps {
  guides: SnapGuidesType;
}

/**
 * Renders visual snap guide lines on the canvas during element drag
 */
export function SnapGuides({ guides }: SnapGuidesProps) {
  const hasGuides = guides.vertical.length > 0 || guides.horizontal.length > 0;

  if (!hasGuides) return null;

  return (
    <>
      {guides.vertical.map((x, i) => (
        <div
          key={`v-${i}`}
          className="snap-guide-vertical"
          style={{ left: x }}
        />
      ))}
      {guides.horizontal.map((y, i) => (
        <div
          key={`h-${i}`}
          className="snap-guide-horizontal"
          style={{ top: y }}
        />
      ))}
    </>
  );
}
